import { EuqTimeRangeEnum, FeedbackFilterCategory } from './type';

export const FeedbackPredefinedStrMap: Record<EuqTimeRangeEnum, string> = {
  [EuqTimeRangeEnum.Last24h]: 'common.timeRange.last24h',
  [EuqTimeRangeEnum.Last1w]: 'common.timeRange.last1w',
  [EuqTimeRangeEnum.Last1M]: 'common.timeRange.last1M',
  [EuqTimeRangeEnum.Last3M]: 'common.timeRange.last3M',
};

export const FeedbackCategoryStrMap: Record<FeedbackFilterCategory, string> = {
  [FeedbackFilterCategory.All]: 'operations.euq.reportAs.type.all',
  [FeedbackFilterCategory.Spam]: 'operations.euq.reportAs.type.spam',
  [FeedbackFilterCategory.Phishing]: 'operations.euq.reportAs.type.phishing',
  [FeedbackFilterCategory.NotSpam]: 'operations.euq.reportAs.type.noRisk',
};
